import React from 'react'
import { formValues } from 'redux-form'
import Scrollbars from 'react-custom-scrollbars'
import { SquareCheckbox } from '../../../../components/FormBuilder'
import { is } from '../../../../components/MediaQuery'
import { isSafari } from '../../../../components/DetectBrowser/DetectBrowser'
import { IRoom } from '../../../../models/Room'
import styled from '../../../../theme'
import { IWithSize } from '../../Calendar/Calendar'

const SafariWrapper = styled.div<IWithSize>`
  margin-bottom: ${({ size }) => (size ? 10 * size : 10)}px;
  max-height: 35vh;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 4px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.4);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.4);
  }
`

const Scroll = styled(Scrollbars)<IWithSize>`
  margin-bottom: ${({ size }) => (size ? 10 * size : 10)}px;
  & > div {
    scroll-behavior: smooth;
    overscroll-behavior: contain;
  }
`

const RoomsCheckboxList = ({ rooms, size = 1 }) => {
  const isDesktop = is.desktop()
  const safari = isSafari()

  if (safari && !isDesktop) {
    return (
      <SafariWrapper size={size}>
        {rooms.map((room: any) => (
          <SquareCheckbox.ReduxField
            size={size}
            fireEventOnClick={true}
            name={`room[${room.id}]`}
            key={room.id}
            label={room.name}
            isHorizontal={true}
            isReverse={true}
            noSpacing={true}
            wrapLabel={true}
            wrapperStyle={{
              justifyContent: 'start',
              marginTop: `${10 * size}px`,
            }}
          />
        ))}
      </SafariWrapper>
    )
  } else
    return (
      <Scroll
        size={size}
        hideTracksWhenNotNeeded={true}
        autoHeight
        autoHeightMax={isDesktop ? '50vh' : '35vh'}
      >
        {rooms.map((room: IRoom) => (
          <SquareCheckbox.ReduxField
            size={size}
            fireEventOnClick={true}
            wrapLabel={true}
            name={`room[${room.id}]`}
            key={room.id}
            label={room.name}
            isHorizontal={true}
            isReverse={true}
            noSpacing={true}
            wrapperStyle={{
              justifyContent: 'start',
              marginTop: `${10 * size}px`,
            }}
          />
        ))}
      </Scroll>
    )
}

export default formValues<any>({ from: 'from', to: 'to' })(RoomsCheckboxList)
